import { render, staticRenderFns } from "./ImageMessage.htm?vue&type=template&id=b0f26ce0&scoped=true&"
import script from "./ImageMessage.ts?vue&type=script&lang=js&"
export * from "./ImageMessage.ts?vue&type=script&lang=js&"
import style0 from "./ImageMessage.scss?vue&type=style&index=0&id=b0f26ce0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0f26ce0",
  null
  
)

export default component.exports